import * as React from "react";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import {OnFailure, OnSuccess} from "../../../../../store/action/actionHelpers";
import Toast from "../../../../helper/Toast";
import CreateUtilityFormView from "./CreateUtilityFormView";
import {notifyBugsnagAndShowToast} from "../../../../../utils/Utils";
import Utility from "../../../../../model/utility/Utility";
import {createUtility} from "../../../../../store/action/utility/utility";

interface IComponentProps {
	/**
	 * Close modal callback
	 */
	closeModal: () => void
}

interface IDispatchProps {
	/**
	 * Create utility.
	 */
	createUtility: (data: Utility, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type Props = IComponentProps & IDispatchProps;

class CreateUtilityForm extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isSubmitting: false};
		this.onSubmit = this.onSubmit.bind(this);
	}

	render() {
		return (
			<CreateUtilityFormView onSubmit={this.onSubmit}
								   onCancel={this.props.closeModal}
								   isSubmitting={this.state.isSubmitting}/>
		);
	}

	onSubmit(data: Utility) {
		this.setState({isSubmitting: true}, () => {
			this.props.createUtility(
				data,
				() => {
					Toast.success("Utility created", "Utility creation");
					this.setState({isSubmitting: false});
					this.props.closeModal();
				},
				(error) => {
					notifyBugsnagAndShowToast(error, "Utility creation");
					this.setState({isSubmitting: false});
				}
			);
		});
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		createUtility: (data: Utility, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(createUtility(data, onSuccess, onFailure))
	};
}

export default connect(null, mapDispatchToProps)(CreateUtilityForm);